// ESM-Konvertierung von lib/scripts/CLS_CTimeOut.js (Phase 4, Welle 1a).
// Zentraler 250ms-Tick fuer registrierte Intervall-Events plus der
// setTimeout-Umweg, ueber den CComponent.eventTrigger verdrahtete
// Handler entkoppelt ausfuehrt (inkl. POS.events.unlock danach).
export class CTimeOut {
  constructor() {
    this.timerEvents = [];
    setTimeout(this.run, 250, this);
  }

  register(name, fnc, parameter, interval, runCount) {
    const newEvent = {
      name, fnc, parameter, interval,
      count: 0,
      runCount: typeof runCount != "undefined" ? runCount : 0,
      curRunCount: 0,
    };
    this.timerEvents.push(newEvent);
  }

  unregister(name) {
    for (let i = 0; i < this.timerEvents.length; i++)
      if (this.timerEvents[i].name == name) {
        this.timerEvents.splice(i, 1);
        return true;
      }
    return false;
  }

  run(me) {
    for (let i = 0; i < me.timerEvents.length; i++) {
      me.timerEvents[i].count++;

      if (me.timerEvents[i].count >= me.timerEvents[i].interval) {
        me.timerEvents[i].count = 0;

        try {
          me.timerEvents[i].fnc(me.timerEvents[i].parameter);
        } catch (e) {
          sdump("FAILED TO EXECUTE", me.timerEvents[i].name, e);
          log.add(1, "Error", "CTimeOut failed to execute", me.timerEvents[i].name +
            " - " + e);
          const stack = e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@')
            .split('\n');
          log.add(1, "Error", "Caught", "Stack: " + stack);
        }

        if (typeof me.timerEvents[i] != "undefined" && me.timerEvents[i].runCount > 0) {
          me.timerEvents[i].curRunCount++;
          if (me.timerEvents[i].curRunCount >= me.timerEvents[i].runCount)
            me.timerEvents.splice(i, 1);
        }
      }
    }

    setTimeout(me.run, 250, me);
  }

  setTimeout(name, fnc, timeout, param1, param2, param3, param4) {
    window.setTimeout(POS.timeout.doSetTimeout, timeout, name, fnc, param1, param2, param3, param4);
  }

  doSetTimeout(name, fnc, param1, param2, param3, param4) {
    try {
      POS.events.lockedBy = name;
      // always statt then: ein abgewiesenes Versprechen (z.B. RKSV-Beleg
      // nicht erstellt) liess die Sperre sonst stehen - danach nahm die Kasse
      // keine Taste mehr an, bis zufaellig ein Eingabefeld angetippt wurde
      // (Testkasse 20.10.2026: "Kasse bleibt haengen").
      $.when(fnc(param1, param2, param3, param4)).always(function () {
        POS.events.unlock();
      });
    } catch (e) {
      log.add(2, "Error", name + " - event execution failed:", e);
      POS.events.unlock();
    }
  }
}
